module.exports = __webpack_public_path__ + "static/assets/3947903ddb159c7e7cd203eb79bda07f.png";